import { render, staticRenderFns } from "./JBProposalMaterialFacts.vue?vue&type=template&id=25fa5553"
import script from "./JBProposalMaterialFacts.vue?vue&type=script&lang=js"
export * from "./JBProposalMaterialFacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports